import styled, { keyframes } from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IContainerProps {
  isShowing: boolean;
  clicked: boolean;
}

export const MissionApprovalContainer = styled.div`
  position: relative;
`
export const ButtonContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: absolute;
  right: 15px;
  top: ${({ positionTop }) => positionTop};
  z-index: 9;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    right: 10px;

    button {
      width: 45px;
      height: 45px;
    }
  }
`
export const Button = styled.button<IContainerProps>`
  width: 45px;
  height: 45px;
  box-shadow: 1px 1px 1px 1px #d8d8d8;

  display: ${({ isShowing }) => isShowing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;

  background: ${({ clicked }) => clicked ? '#4DB755' : customTheme.colors.white};
  border-radius: 100%;
  border: none;
  text-align: center;
  color: ${({ color }) => color || customTheme.colors.black};
  cursor: pointer;

  &:hover { 
    background: ${({ clicked }) => clicked ? '#98d19d' : '#f1f1f1'} ;
  }
`
const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`
export const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border: 4px solid transparent;
  border-left-color: ${({ color }) => color || '#fff'};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`

export const ModalContainer = styled.div<any>`
  position: absolute;
  top: ${({ positionTop }) => positionTop}vh;
  right: 70px;
  z-index: 99;

  width: 420px;
  max-width: 90%;
  max-height: 400px;
  padding: 20px 10px 20px 20px;
 

  
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;

  background: #fffffffa;
  border: 1.84534px solid rgba(188, 188, 188, 0.74);
  box-shadow: 0px 7.23636px 35.2773px rgba(0, 0, 0, 0.18);
  backdrop-filter: blur(54.4375px);
  border-radius: 20px 0px 20px 20px;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    right: 50px;
    top: ${({ positionTop, isMissionTrigger }) => isMissionTrigger ? positionTop - 25 : positionTop}vh;
  }

`

export const ModalContent = styled.div`
  width: 100%;
  padding-right: 10px;
  overflow-y: auto;
  overflow-x: hidden;

  & {
    scrollbar-width: thin;
    scrollbar-color: #f1f1f1;
  }

  &::-webkit-scrollbar {
    width: 12px;
    position: relative;
    right: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #ececec;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #444;
    border-radius: 20px;
    border: 3px solid rgba(255,255,255, .19);
  }

  h2 {
    margin-bottom: 20px;
    text-align: center;
  }

  button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #5aff5a;
    border: 2px solid #606060;
    opacity: 1;
    box-sizing: border-box;
    box-shadow: 0px 4px 16px rgb(0 0 0 / 50%);
    border-radius: 10vw;
    font-family: Poppins;
    font-weight: bold;
    font-size: 18px;
    line-height: 1.2;
    color: #000000;
    cursor: pointer;
    padding: 15px;
  }

  label {
    font-size: 0.8em;
    font-weight: bold;
    margin-bottom: 2px;
    color: #fff;
  }

  .title {
    display: flex;
    color: #444;
    padding-top: 15px;

    > * {
      padding: 5px;
    }
  }
  
  a {
    text-decoration: none;
    width: 100%;
  }
`

export const CloseModal = styled.div`
  position: absolute;
  background: none;
  border: none;
  right: -10px;
  top: -10px;
  color: #444;
  font-weight: bold;
  cursor: pointer;
  outline: none;
  
  svg {
    width: 30px;
  }
`

export const Review = styled.div`
 display: flex;
 flex-direction: column;
 margin-bottom: 10px;
 padding: 0 11px;

  &.align-left {
    align-items: flex-start
  }

  &.align-right {
    align-items: flex-end
  }
`

export const ReviewInfo = styled.div`
 display: flex;
 flex-direction: column;
 align-items: flex-start;
 gap: 3px;
 margin-bottom: 5px;
 padding: 0 10px;
`
export const Content = styled.div`
 border: 2px solid #d8d8d8;
 padding: 10px;
 border-radius: 20px;
 background: #ffffff9e;
 box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
 margin-left: 10px;
 width: 90%;
`

export const Name = styled.div`
  b {
    font-size: 13px;
  }
  &.text-left {
    text-align: left;
  }

  &.text-right {
    text-align: right;
}
`

export const CreatedAtDate = styled.div`
  font-size: 12px;
  font-weight: 600;
`

export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  margin-top: 20px;
  flex-direction: column;

  &.align-left {
    align-items: flex-start
  }

  &.align-right {
    align-items: flex-end
  }

`

export const TextArea = styled.textarea`
  width: 90%;
  height: 100px;
  font-size: 16px;
  font-weight: 600;
  resize: none;
  border: 2px solid #8d8d8d;
  padding: 10px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  margin-left: 10px;
  margin-bottom: 5px;
`

export const InputName = styled.input`
  width: 98%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  border: 2px solid #d8d8d8;
  padding: 10px;
  border-radius: 20px;
  background: #ffffff9e;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.15);
  margin-bottom: 10px;
  margin-left: 10px;
`

export const ButtonBox = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
`

export const ButtonSubmit = styled.button`
width: 40% !important;
height: 45px;
box-shadow: none !important;

display: flex;
align-items: center;
justify-content: center;

border-radius: 20px;
border: none;
font-weight: bold;
font-size: 32px;
line-height: 37px;
text-align: center;
color: ${({ color }) => color || customTheme.colors.black};
cursor: pointer;

  &:hover { 
    background: #00af00;
    color: #f1f1f1;
  }
`
